import { Settings } from 'lucide-react';
import UserIndicator from '../UserIndicator';
import RunButton from './RunButton';
import MobileProjectSwitcher from './MobileProjectSwitcher';

interface MobileHeaderProps {
  projectPath?: string;
  onSettingsOpen: () => void;
}

export default function MobileHeader({ projectPath, onSettingsOpen }: MobileHeaderProps) {
  return (
    <div
      className="h-12 bg-base-200 border-b border-base-300 flex items-center px-2 gap-1 flex-shrink-0"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      {/* Top-level project switcher (tap the name to switch projects) */}
      <MobileProjectSwitcher />

      {/* Run */}
      <RunButton projectPath={projectPath} compact />

      {/* Settings */}
      <button onClick={onSettingsOpen} className="btn btn-ghost btn-sm btn-square" aria-label="Settings">
        <Settings className="w-4 h-4" />
      </button>

      {/* User indicator */}
      <UserIndicator />
    </div>
  );
}
